export default "__VITE_ASSET__lQtiHijL__"